import React from 'react';
import { Container, Box, Typography, Card, CardContent, Avatar, Grid, Stack } from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import BadgeIcon from '@mui/icons-material/Badge';

const Profile = ({ user }) => {
  return (
    <Container maxWidth="sm">
      <Box mt={6} mb={4}>
        <Typography
          variant="h4"
          gutterBottom
          align="center"
          sx={{ fontWeight: 'bold' }}
        >
          Perfil del Usuario
        </Typography>

        <Card elevation={3} sx={{ borderRadius: 3 }}>
          <CardContent>
            <Grid container spacing={2} alignItems="center">
              <Grid item>
                <Avatar sx={{ bgcolor: 'primary.main', width: 60, height: 60 }}>
                  <AccountCircleIcon sx={{ fontSize: 40 }} />
                </Avatar>
              </Grid>
              <Grid item xs>
                <Typography variant="h6" sx={{ fontWeight: 'medium' }}>
                  {user.nombre}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {user.email}
                </Typography>
              </Grid>
            </Grid>

            <Box mt={3}>
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                Información adicional
              </Typography>

              <Stack spacing={1}>
                <Box display="flex" alignItems="center" gap={1}>
                  <PhoneIcon color="action" />
                  <Typography variant="body2" color="text.secondary">
                    {user.telefono || "-"}
                  </Typography>
                </Box>

                <Box display="flex" alignItems="center" gap={1}>
                  <EmailIcon color="action" />
                  <Typography variant="body2" color="text.secondary">
                    {user.email || "-"}
                  </Typography>
                </Box>

                <Box display="flex" alignItems="center" gap={1}>
                  <BadgeIcon color="action" />
                  <Typography variant="body2" color="text.secondary">
                    {user.documento_tipo}:{user.documento || "-"}
                  </Typography>
                </Box>
              </Stack>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default Profile;
